export default "__VITE_ASSET__34f46e37__"